import { useEffect, useState } from 'react'
import resolveConfig from 'tailwindcss/resolveConfig'
import tailwindConfig from '../../tailwind.config.js'

// @ts-ignore
const fullConfig = resolveConfig(tailwindConfig)

export type TTailwindBreakpoints = 'xs' | 'sm' | 'md' | 'lg' | 'xl'

export const getBreakpointValue = (value: TTailwindBreakpoints): number =>
  parseInt(fullConfig.theme.screens[value].replace('px', ''), 10)

export const getCurrentBreakpointFromWidth = (
  width: number
): TTailwindBreakpoints => {
  const breakPoints: TTailwindBreakpoints[] = ['xs', 'sm', 'md', 'lg', 'xl']
  const sortedBreakPointsValues: {
    key: TTailwindBreakpoints
    value: number
  }[] = breakPoints
    .map((breakpoint) => {
      return {
        key: breakpoint,
        value: getBreakpointValue(breakpoint),
      }
    })
    .sort((a, b) => b.value - a.value)

  for (const breakpoint of sortedBreakPointsValues) {
    if (width >= breakpoint.value) {
      return breakpoint.key
    }
  }

  return 'xs'
}

export const useToggleResponsiveContent = ({
  desktopContent,
  mobileContent,
  breakpoint,
}: {
  desktopContent: any
  mobileContent: any
  breakpoint: TTailwindBreakpoints
}) => {
  const [returnValue, setReturnValue] = useState(desktopContent)

  const updateMedia = () => {
    const filteredItems =
      window.innerWidth < getBreakpointValue(breakpoint)
        ? mobileContent
        : desktopContent
    setReturnValue(filteredItems)
  }

  useEffect(() => {
    updateMedia()
    window.addEventListener('resize', updateMedia)

    return () => window.removeEventListener('resize', updateMedia)
  }, [])

  return returnValue
}
